module.exports = require('./helpers/bundle-url').getBundleURL('9rAa3') + "slack-logo.5d730c10.svg";